import React, { SVGProps } from "react";

interface ShieldIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ShieldIcon: React.FC<ShieldIconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M21.7061 13.7409L16.4701 4.74938L16.4598 4.73157C15.9887 3.97309 15.3319 3.3473 14.5515 2.91337C13.7712 2.47944 12.893 2.25171 12.0001 2.25171C11.1072 2.25171 10.2291 2.47944 9.44873 2.91337C8.66837 3.3473 8.01158 3.97309 7.54044 4.73157L7.53013 4.74938L2.29419 13.7409C1.80301 14.5361 1.53301 15.448 1.51206 16.3823C1.49112 17.3167 1.71999 18.2398 2.17504 19.0561C2.6301 19.8725 3.29483 20.5526 4.1006 21.0262C4.90636 21.4997 5.82394 21.7496 6.75857 21.75H17.2417C18.1763 21.7496 19.0939 21.4997 19.8997 21.0262C20.7054 20.5526 21.3702 19.8725 21.8252 19.0561C22.2803 18.2398 22.5091 17.3167 22.4882 16.3823C22.4673 15.448 22.1972 14.5361 21.7061 13.7409ZM15.0001 20.25H9.00013V15.75H15.0001V20.25ZM20.5183 18.3234C20.1973 18.9108 19.7231 19.4001 19.1461 19.7393C18.5691 20.0786 17.911 20.2551 17.2417 20.25H16.5001V15.75C16.5001 15.3522 16.3421 14.9706 16.0608 14.6893C15.7795 14.408 15.398 14.25 15.0001 14.25H9.00013C8.60231 14.25 8.22078 14.408 7.93947 14.6893C7.65817 14.9706 7.50013 15.3522 7.50013 15.75V20.25H6.75857C6.09011 20.2502 5.43376 20.0717 4.85745 19.733C4.28115 19.3943 3.80586 18.9078 3.48078 18.3237C3.15571 17.7396 2.99266 17.0792 3.00854 16.411C3.02441 15.7427 3.21862 15.0908 3.57107 14.5228C3.57486 14.5168 3.5783 14.5105 3.58138 14.5041L8.81732 5.51344C9.15441 4.97409 9.62314 4.52935 10.1794 4.22102C10.7357 3.9127 11.3613 3.75093 11.9973 3.75093C12.6333 3.75093 13.2589 3.9127 13.8152 4.22102C14.3715 4.52935 14.8402 4.97409 15.1773 5.51344L20.4133 14.5041C20.4163 14.5105 20.4198 14.5168 20.4236 14.5228C20.7813 15.0887 20.9789 15.7409 20.9954 16.4102C21.0119 17.0794 20.8467 17.7406 20.5173 18.3234H20.5183Z"
        fill="#A4A7AE"
      />
    </svg>
  );
};
